import React from 'react';
import styled from 'styled-components';
import spiceImg from '../../assets/img/affSpice.png';
import shrimpImg from '../../assets/img/contactShrimp.png';
import {BodyContainer} from "../Container/Container";
import {LeftArrow, RightArrow} from "../Home/Affiliations";
import Slider from 'react-slick';

const StyledBodyContainer = BodyContainer.extend`
  position: relative;
  
  margin-bottom: -32px;
  @media(min-width: 768px) {
      padding-bottom: 0;  
      margin-bottom: -100px;
   }
  
  @media(min-width: 992px) {
      padding-bottom: 0;  
  }
  
  @media(min-width: 1200px) {
      padding-bottom: 0;  
  }
  
  @media(min-width: 1680px) {
      padding-bottom: 0;  
  }
`;

const SpiceImg = styled.img` 
  position: absolute;
  left: 0;
  z-index: 0;
  display: none;
  
  @media(min-width: 992px) {
    display: block;
    height: 20vw;
  }
`;

const ShrimpImg = styled.img`
  position: absolute;
  right: 0;
  z-index: 0;
  display: none;
  
  @media(min-width: 992px) {
    display: block;
    height: 20vw;
  }
`;

const LogoContainer = styled.div`
  z-index: 1;
  justify-content: center;
  flex-wrap: wrap;
  display: none;
  
  @media(min-width: 992px) {
    display: flex;
  }
`;

const SingleContainer = styled.div`
   img {
      width: auto;
    }
  
  @media(min-width: 992px) {
    flex-basis: 33%;
    display: flex;
    justify-content: center;
    margin-bottom: 120px;
  }
  
  @media(min-width: 1200px) {
    flex-basis: 25%;
  }
`;

const SliderContainer = styled.div`
  padding: 0 20px;
  display: block;
  
  @media(min-width: 992px) {
    display: none;
  }
  
  a{
    display: flex;
    justify-content: center;
  }
  
  img{
      height: 64px !important;
  }
`;

const AffiliationLogos = (props) => {
    const {logos} = props;
    const settings = {
        dots: false,
        nextArrow: <RightArrow/>,
        prevArrow: <LeftArrow/>,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
    };
    return (
      <StyledBodyContainer>
          <SpiceImg src={spiceImg}/>
          <ShrimpImg src={shrimpImg}/>
          <SliderContainer>
              <Slider {...settings}>
                  {logos.map(i => {
                      const {link, logo: {source_url, alt_text}} = i.node.acf;
                      return (
                        <SingleContainer>
                            <a href={`https://${link}`} target="_blank" title={`${i.link}`}>
                                <img
                                  src={source_url}
                                  alt={alt_text}
                                />
                            </a>
                        </SingleContainer>
                      )
                  })}
              </Slider>
          </SliderContainer>
          <LogoContainer>
              {logos.map(i => {
                  const {link, logo: {source_url, alt_text}} = i.node.acf;
                  return (
                    <SingleContainer>
                        <a href={`https://${link}`} target="_blank">
                            <img
                              src={source_url}
                              alt={alt_text}
                            />
                        </a>
                    </SingleContainer>
                  )
              })}
          </LogoContainer>
      </StyledBodyContainer>
    );
};

export default AffiliationLogos;



// WEBPACK FOOTER //
// ./src/components/Affiliations/AffiliationLogos.js